define(
    'Code25.CaterpartsGlobal.FilterAddresses', [
    "underscore", "jQuery"
],
    function (
        _, $
    ) {
        'use strict';

        return {
            mount: function mount(container) {
                
                function updateFilter(e) {
                            var keyword = e.target.value;
                            if (this.keyword != keyword) {
                                this.keyword = keyword;
                                var $infos = this.$el.find(".address-details-info");
                                var $cell;
                                $infos.each(function (e) {
                                    var $this = $(this);
                                    $cell = $this.closest(".order-wizard-address-row");
                                    if (allowAddress($this.text(), keyword)) {
                                        $cell.show();
                                    } else {
                                        $cell.hide();
                                    }
                                })

                            }
                        }

                        function allowAddress(text, keyword) {
                            if (keyword && text) {
                                text = text.toLowerCase();
                                var keywords = keyword.toLowerCase().split(" ");
                                var allowAddress;

                                allowAddress = true;
                                for (var k = 0; k < keywords.length; k++) {
                                    if (text.indexOf(keywords[k]) == -1) {
                                        allowAddress = false;
                                        break;
                                    }
                                }
                                return allowAddress;

                            }
                            return true;
                        }
                    if (SC.ENVIRONMENT.SCTouchpoint != "shopping") {

                        

                        var View, views = ['OrderWizard.Module.Address', 'OrderWizard.Module.MultiShipTo.Select.Addresses.Shipping'];
                        for (var i = 0; i < views.length; i++) {
                            try {
                                View = require(views[i]);

                                _.extend(View.prototype, {
                                    initialize: _.wrap(View.prototype.initialize, function (initialize) {
                                        initialize.apply(this, _.rest(arguments));
                                        this.itemsPerRow = 1;
                                    })
                                    ,
                                    updateFilter: updateFilter
                                });

                                View.prototype.events['change input[type="text"]'] = 'updateFilter';
                                View.prototype.events['keyup input[type="text"]'] = 'updateFilter';
                            } catch (err) {

                            }

                        }

                    }
                

            }
        };
    });
